import { defineMessages } from 'react-intl'

export default defineMessages({
    subject: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.subject',
        defaultMessage: 'Thank you for auditioning for {orderName}',
    },
    message: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.message',
        defaultMessage: "Dear {supplierFirstName},\n\nThank you so much for taking the time to audition for {orderName}. We truly appreciate the effort and talent you brought to the project.\n\nWhile the client has chosen a different direction for this particular project, we value your work and are excited about working together on future projects. We truly appreciate your flexibility and willingness to work with us.\n\nWe look forward to reaching out soon with new projects!",
    },
    rejectSuccess: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.rejectSuccess',
        defaultMessage: 'Successfully rejected suppliers',
    },
    modalTitle: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.modalTitle',
        defaultMessage: 'Reject',
    },
    subjectLabel: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.subjectLabel',
        defaultMessage: 'Subject',
    },
    messageLabel: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.messageLabel',
        defaultMessage: 'Message',
    },
    loading: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.loading',
        defaultMessage: 'Loading',
    },
    submit: {
        id: 'frontend.app.containers.AuditionScopePage.components.SubmittedTable.components.SubmittedTableRejectModel.update',
        defaultMessage: 'Submit',
    }
})
